import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/partials/user-rank.module.scss';

const propTypes = {
    user: AppPropTypes.user.isRequired,
    participant: PropTypes.shape({
        points: PropTypes.number,
        name: PropTypes.string,
    }),
    className: PropTypes.string,
};

const defaultProps = {
    participant: null,
    className: null,
};

function UserRank({ user, participant, className }) {
    const { name: theme } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const { stats = {} } = user || {};
    const { leaderboardPosition = null, score = null } = stats || {};
    const { name } = participant || {};

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.title}>
                <FormattedMessage defaultMessage="My rank" description="User rank title" />
            </div>
            <div className={styles.row}>
                {leaderboardPosition !== null ? (
                    <div className={styles.position}>
                        {leaderboardPosition < 9
                            ? `0${leaderboardPosition + 1}`
                            : leaderboardPosition}
                    </div>
                ) : null}
                <div className={styles.label}>
                    {name !== null ? <div className={styles.name}>{name}</div> : null}
                </div>
                {score !== null ? <div className={styles.points}>{score}</div> : null}
            </div>
        </div>
    );
}

UserRank.propTypes = propTypes;
UserRank.defaultProps = defaultProps;

export default UserRank;
